/**
@format
@flow
*/

import type {
  MediaUploadReference, ContentType, UploadedMediaSources,
} from '@ziynx/flow-types/media';

import type { RefinedCompanyVideos } from '@ziynx/flow-types/companyProfile';

type ProfileImageObject = {
  _id: string,
  image: {
    uri: string,
    type: ContentType,
  },
  original: {
    uri: string,
    _id: string,
    type: ContentType,
  }
};

type CompanyVideos = {
  title: string,
  video: {
    _id: string,
    contentType: ContentType,
    cropStatus: string, // fix
    sources: UploadedMediaSources,
  }
};

const setupProfileImage = (
  companyProfileImage: {...MediaUploadReference, _id: string},
): ProfileImageObject => {
  if (
    !companyProfileImage
    || !companyProfileImage?.sources
    || !companyProfileImage.sources
  ) { return {}; }

  const { _id } = companyProfileImage;
  const { original, cropped } = companyProfileImage?.sources;

  return {
    _id,
    image: {
      uri: cropped?.url || original?.url,
      type: cropped?.contentType || original?.contentType,
    },
    original: {
      uri: original?.url,
      type: original?.contentType,
      _id: original?._id,
    },
  };
};

const setupCompanyVideos = (
  companyVideoArray: Array<CompanyVideos>,
): Array<RefinedCompanyVideos> => {
  const refinedArray = new Array(3).fill({});

  if (!companyVideoArray || !companyVideoArray?.length) {
    return refinedArray;
  }

  for (let i = 0; i < companyVideoArray.length; i += 1) {
    const { title, video } = companyVideoArray[i] || {};
    const {
      original,
      thumbnail,
      mp4,
    } = video?.sources || {};

    refinedArray[i] = {
      _id: video?._id,
      title,
      thumbnail: {
        uri: thumbnail?.url,
      },
      original: {
        uri: original?.url,
      },
      video: {
        uri: mp4?.url,
      },
    };
  }

  return refinedArray;
};

export { setupProfileImage, setupCompanyVideos };
